import React from 'react'

const Footer = () =>
  <div className="Footer container text-gray-500 text-center mt-16 pb-4">
    © {new Date().getFullYear() || 2020} Conner Fritz
  </div>

export default Footer
